import { useState } from "react";
import { Button, IconCardCheckbox } from "@common";
import styles from "./styles.module.scss";
import {
  AnimalDrumsticks,
  Dollar,
  HouseDoor,
  NaturalDisasterHurricane,
  Notebook,
  Stomach
} from "@assets/Icons";

const DATA = {
  "Marriage or relationship": HouseDoor,
  "Busy work or family life": Notebook,
  "Financial struggles": Dollar,
  "High stress or anxiety": NaturalDisasterHurricane,
  "Slower metabolism due to aging": Stomach,
  "None of the above": AnimalDrumsticks
};

export const PastEvents = ({ onNextStep, onTrackEvent }) => {
  const [checked, setChecked] = useState([]);

  const handleCheck = (value) => {
    setChecked((prevState) => {
      if (prevState.includes(value)) {
        return prevState.filter((item) => item !== value);
      }

      if (value === "None of the above") {
        return ["None of the above"];
      }

      return [
        ...prevState.filter((item) => item !== "None of the above"),
        value
      ];
    });
  };

  const handleNextStep = () => {
    console.log(checked);
    onTrackEvent(checked);
    onNextStep(checked);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>
          Have any of the following events influenced your weight in the past
          several years?
        </h2>
        <p className={styles.hint}>Choose all that apply</p>
        <div className={styles.cards}>
          {Object.entries(DATA).map(([value, Icon]) => (
            <IconCardCheckbox
              checked={checked.includes(value)}
              onClick={() => handleCheck(value)}
              img={<Icon />}
              title={value}
              key={value}
            />
          ))}
        </div>
      </div>
      <div className={styles.action}>
        <Button disabled={!checked.length} onClick={handleNextStep}>
          Continue
        </Button>
      </div>
    </div>
  );
};
